import { RefObject } from 'react';

export const scrollToElement = (
  elementRef: RefObject<HTMLElement>,
  behavior: ScrollBehavior | undefined = 'smooth'
) => {
  const elementNode = elementRef && elementRef.current;
  if (elementNode) {
    const rect = elementNode.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (!isVisible) {
      elementNode.scrollIntoView({ behavior, block: 'start' });
    }
  }
};
